import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { Col, Form, Row } from 'react-bootstrap'
import { EMPTY_OBJECT, getSvgIcon } from '../../../constants/globalConstants'
import { Circles } from 'react-loader-spinner'
import { createDefaultMaskGenerator, MaskedInput } from 'react-hook-mask'
import cardNumberImage from '../../../assets/img/cardimgpppp.png'
import backcvvv from '../../../assets/img/backcvvv.png'
import MiniHeader from '../MiniHeader'
import { addCard, getCardLists } from '../../../redux/actions/PaymentAction'
// import axios from 'axios'
import { errorMessage } from '../../../constants/errorMessage'
import { encryptionHandler, getCardIcon } from '../../../utils/helper'
// import dummyCard from '../../../assets/img/card_top.png'
import { useNavigate, useParams } from 'react-router-dom'
// import visaCard from '../../../assets/img/visa_img.png'
// import masterCard from '../../../assets/img/master_img.png'

const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
const expirymask = createDefaultMaskGenerator('99/99')
const cvvmask = createDefaultMaskGenerator('9999')
function PaymentGateDc(props) {

    const { isTokenApiStarts, isInScreen, dispatch, notify, setIsPaymentModalOpen } = props
    const { register, handleSubmit, onSubmit, formState: { errors }, control, setFocus } = useForm()
    const [isFetching, setIsFetching] = useState(false)
    const navigate = useNavigate()
    const {partner} = useParams()
    const { ref } = register('name_on_card')

    useEffect(() => {
        setFocus('name_on_card')
    }, [setFocus])

    const handleCardAdd = (data) => {
        // const dcapData = JSON.parse(localStorage.getItem('dcap'))
        // const payload = {
        //     'Account': data?.card_number ? data?.card_number : '',
        //     'ExpirationMonth': data?.expiry ? data?.expiry.substr(0, 2) : '',
        //     'ExpirationYear': data?.expiry ? `20${data?.expiry.substr(2, 5)}` : '',
        //     'CVV': data?.cvv ? data?.cvv : ''
        // }
        setIsFetching(true)
        // const headers = { 'Authorization': dcapData?.DATACAP_TOKEN, 'Content-Type': 'application/json', Accept: 'application/json' }
        // axios.post(dcapData?.DATACAP_OTU_URL, payload, { headers })
        //     .then((response) => {
        //         if (response?.data) {
        //             const card = {
        //                 name_on_card: data?.name_on_card,
        //                 card_number: data?.card_number,
        //                 expiration_date: data?.expiry,
        //                 security_code: data?.cvv,
        //                 zip_code: ''
        //             }
        //             const nonce = encryptionHandler(card)
        //             const cardData = {
        //                 nonce: nonce,
        //                 token: response?.data?.Token,
        //                 payment_type: 'credit_card',
        //                 savePaymentMethod: true,
        //             }
        //             dispatch(addCard(cardData)).then((res) => {
        //                 if (res?.data) {
        //                     notify('success', 'Card Added Succesfully')
        //                     if (!isInScreen) {
        //                         navigate(`/${partner}/payment-list`)
        //                     }else{
        //                         dispatch(getCardLists())
        //                     }   
                            
        //                     setIsPaymentModalOpen(false)
        //                     setIsFetching(false)
        //                 } else {
        //                     notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
        //                     if (!isInScreen) {
        //                         navigate(`/${partner}/payment-list`)
        //                     }else{
        //                         dispatch(getCardLists())
        //                     } 
        //                     // setIsPaymentModalOpen(false)
        //                     setIsFetching(false)
        //                 }
        //             }).catch((err) => {
        //                 notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        //                 if (!isInScreen) {
        //                     navigate(`/${partner}/payment-list`)
        //                 }else{
        //                     dispatch(getCardLists())
        //                 } 
        //                 setIsFetching(false)
        //                 // setIsPaymentModalOpen(false)
        //             })
        //             // finalPaymentToBackend(response?.data, data)
        //         } else if (response?.Error) {
        //             // setIsTokenApiStart(false)
        //             notify('error', response?.data ? response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
        //             // setIsPaymentModalOpen(false)
        //             setIsFetching(false)
        //         }
        //     }).catch((err) => {
        //         // setIsTokenApiStart(false)
        //         notify('error', err?.response?.data ? err?.response?.data?.Errors?.[0] : errorMessage?.somethingWentWrong)
        //         // setIsPaymentModalOpen(false)
        //         setIsFetching(false)
        //     })
        const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
        const localFacilityID = facilityLocData?.facility?.id ? facilityLocData.facility.id : null
        const card = {
            name_on_card: data?.name_on_card,
            card_number: data?.card_number,
            expiration_date: data?.expiry,
            security_code: data?.cvv,
            zip_code: ''
        }
        const nonce = encryptionHandler(card)
        const cardData = {
            nonce: nonce,
            payment_type: 'credit_card',
            savePaymentMethod: true,
            facility_id: localFacilityID
        }
        dispatch(addCard(cardData)).then((res) => {
            if (res?.data) {
                notify('success', 'Card Added Succesfully')
                if (!isInScreen) {
                    navigate(`/${partner}/payment-list`)
                }else{
                    dispatch(getCardLists(localFacilityID))
                }   
                
                setIsPaymentModalOpen(false)
                setIsFetching(false)
            } else {
                notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                if (!isInScreen) {
                    navigate(`/${partner}/payment-list`)
                }else{
                    dispatch(getCardLists(localFacilityID))
                } 
                // setIsPaymentModalOpen(false)
                setIsFetching(false)
            }
        }).catch((err) => {
            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
            if (!isInScreen) {
                navigate(`/${partner}/payment-list`)
            }else{
                dispatch(getCardLists(localFacilityID))
            } 
            setIsFetching(false)
            // setIsPaymentModalOpen(false)
        })
    }

    const todayDt = new Date()
    const today = (todayDt.getFullYear() + '' + (todayDt.getMonth() + 1)).slice(2)

    const validateExpiry = (MMYY) => {
        let newArr = []
        let newArr2 = []
        for(let x = 0; x<4; x++) {
            let ar = MMYY.split('')
            if(x<2) {
                newArr.push(ar[x])
            } else {
                newArr2.push(ar[x])
            }
        }
        // parseInt(today) <= parseInt([...newArr2, ...newArr].join('')), 'nnn')
        return parseInt(today) <= parseInt([...newArr2, ...newArr].join(''))
    }

    return (
        <div>
            {(!isInScreen) && <MiniHeader title='ADD NEW CARD' isDisplayBack />}
            <Form onSubmit={handleSubmit(handleCardAdd)}>
                <section className="my-3 p-3 pt-1">
                    {/* <p className='fw-normal'>Enter Payment Details</p> */}
                    <div className='border rounded pt-2 p-3 mb-3'>
                        <div className='d-flex justify-content-between mb-2 p-2 '>
                            <div className='d-inline-flex'>
                                <div className='me-2' style={{ height: '30px', width: '30px' }}>{getSvgIcon('Credit_card', 'var(--bs-primary)')}</div>
                                <small className='text-black mt-1' style={{width: '6rem' }}>Card Details</small>
                            </div>
                            <div className='text-end'>
                                <img className='img-30 me-2' src={getCardIcon('visa')} alt="dummycard" />
                                <img className='img-20' src={getCardIcon('mastercardpng')} alt="dummycard" />
                            </div>
                        </div>
                        <Form.Group >
                            <Form.Label className='paymentCardDetials small'>Name on Card</Form.Label>
                            <Form.Control type="text" autoComplete="off"
                                name='name_on_card'
                                className="form-control"
                                id='name_on_card'
                                maxLength={20}
                                minLength={1}
                                ref={(e) => { ref(e) }}
                                placeholder="Enter Your Name"
                                {...register('name_on_card',
                                    {
                                        required: { value: true, message: 'This field is required' },
                                    })} />
                            {errors?.name_on_card && <Form.Text className="text-danger header-s">{errors?.name_on_card?.message}</Form.Text>}
                        </Form.Group>

                        <Form.Group >
                            <Form.Label htmlFor="cardNumber" className='paymentCardDetials small'>Card Number</Form.Label>
                            <Controller
                                name="card_number"
                                type="text"
                                id="card_number"
                                control={control}
                                inputMode="numeric"
                                rules={{
                                    pattern: { value: /[0-9]{14}/, message: 'Please enter a valid Card Number' },
                                    required: { value: true, message: 'This field is required' },
                                    minLength: { value: 14, message: 'Please enter a valid Card Number' },
                                    maxLength: { value: 16, message: 'Please enter a valid Card Number' },
                                }}

                                render={({ field }) => <span className='cardNumberCardImage d-block'> <MaskedInput
                                    maskGenerator={cardnumbermask}
                                    autoComplete="off"
                                    inputMode="numeric"
                                    maxLength='19'
                                    {...field}
                                    id="card_number"
                                    className="form-control"
                                    placeholder="Enter Card Number"
                                /><img src={cardNumberImage} className='imgCardfront' alt="card" /></span>}
                            />
                            {errors?.card_number && <Form.Text className="text-danger header-s">{errors?.card_number?.message}</Form.Text>}
                        </Form.Group>
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label htmlFor="expiry" className='paymentCardDetials small'>Expiry Date</Form.Label>
                                    <Controller
                                        name="expiry"
                                        type="text"
                                        id="expiry"
                                        control={control}
                                        inputMode="numeric"
                                        rules={{
                                            pattern: { value: /^(0[1-9]|1[0-2])\d{2}$/, message: 'Please enter a valid date' },
                                            required: { value: true, message: 'This field is required' },
                                            minLength: { value: 4, message: 'Please enter a valid date' },
                                            maxLength: { value: 5, message: 'Please enter a valid date' },
                                            validate: (value) => {
                                                let valid = validateExpiry(value)
                                                if(!valid) {
                                                    return 'Please enter a valid date'
                                                }
                                            },
                                        }}

                                        render={({ field }) => <span className='cardNumberCardImage'> <MaskedInput
                                            maskGenerator={expirymask}
                                            autoComplete="off"
                                            maxLength='5'
                                            inputMode="numeric"
                                            {...field}
                                            id="expiry"
                                            className="form-control"
                                            placeholder="MM/YY"
                                        /></span>}
                                    />
                                    {errors?.expiry && <Form.Text className="text-danger header-s">{errors?.expiry?.message}</Form.Text>}
                                </Form.Group>
                            </Col>

                            <Col>
                                <Form.Group>
                                    <Form.Label htmlFor="CVV" className='paymentCardDetials small'>CVC/CVV</Form.Label>
                                    <Controller
                                        name="cvv"
                                        type="password"
                                        id="Cvv"
                                        className='d-inline-flex'
                                        control={control}
                                        inputMode="numeric"
                                        rules={{
                                            pattern: { value: /[0-9]{3,4}/, message: 'Please enter a valid CVV' },
                                            required: { value: true, message: 'This field is required' },
                                            minLength: { value: 3, message: 'Please enter a valid CVV' },
                                            maxLength: { value: 4, message: 'Please enter a valid CVV' },
                                        }}

                                        render={({ field }) => <span className='cardNumberCardImage d-block'> <MaskedInput
                                            maskGenerator={cvvmask}
                                            autoComplete="off"
                                            type={'password'}
                                            maxLength='4'
                                            {...field}
                                            inputMode="numeric"
                                            id="Cvv"
                                            className="form-control d-inline-flex"
                                            placeholder="CVV"
                                        /><img src={backcvvv} className='imgCardfront2' alt="card" /></span>}
                                    />
                                    {errors?.cvv && <Form.Text className="text-danger header-s">{errors?.cvv?.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <button type="submit" name="submit" className="btn w-100 my-4 text-white bg-primary" onClick={onSubmit} disabled={(isFetching || isTokenApiStarts) ? true : false} >
                                <div className='d-flex justify-content-center align-items-center'>
                                    <span>Add Card </span>  <span className='ms-2'>
                                        {(isFetching) ? <Circles
                                            height="20"
                                            width="20"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /> : null}
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>
                </section>
            </Form>
        </div >
    )
}

PaymentGateDc.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    errors: PropTypes.object,
    faciltyData: PropTypes.object,
    register: PropTypes.func,
    control: PropTypes.func,
    onSubmit: PropTypes.func,
    isTokenApiStarts: PropTypes.bool,
    isInScreen: PropTypes.bool,
    isInTransient: PropTypes.bool,
    notify: PropTypes.func,
    setIsPaymentModalOpen: PropTypes.func,
}

PaymentGateDc.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    faciltyData: EMPTY_OBJECT,
    totalHoursLength: EMPTY_OBJECT,
    partner: '',
    totalInputValues: EMPTY_OBJECT,
    onSubmit: noop,
    isTokenApiStarts: false,
    isInScreen: false,
    notify: noop,
    setIsPaymentModalOpen: noop,
    isInTransient: false,

}

function mapStateToProps({ transientReducer, PaymentReducer }) {
    return {
        loader: transientReducer?.loader,
        // isFetching: transientReducer?.isFetching,
        cards: PaymentReducer?.data
    }
}
export default connect(mapStateToProps)(PaymentGateDc)